export const fetchKnownNextPaths = async () => {
  try {
    const response = await fetch('/api/v1-compat/known-next-paths')
    const {KNOWN_NEXT_PATHS} = await response.json()
    return KNOWN_NEXT_PATHS || []
  } catch (error) {
    console.error('Error fetching known next paths:', error)
    return []
  }
}
